// @flow

import actionCreators from "@modules/reporting/actionCreator";
import { all, call, put, takeEvery } from "redux-saga/effects";
import type { Action } from "redux-action";
import {
  GetManagerDetails,
  GetManagerDetailsLogins,
  GetManagerDetailsTasks,
} from "@modules/reporting/constants/actions";
import http from "@http";

type ManagerRequest = $Exact<{
  clientId: number,
  employeeId: number,
}>;

export function* onGetManagerDetails({ payload }: Action<ManagerRequest>): Generator<*, void, *> {
  try {
    if (!payload || !payload.clientId || !payload.employeeId) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.get,
      `/api/v1/employee-admin/client/${payload.clientId}/employee/${payload.employeeId}`,
    );

    yield put(actionCreators.GetManagerDetailsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetManagerDetailsError(e.response));
  }
}

export function* onGetManagerDetailsLogins({
  payload,
}: Action<ManagerRequest>): Generator<*, void, *> {
  try {
    if (!payload || !payload.clientId || !payload.employeeId) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.get,
      `/api/v1/reports/client/${payload.clientId}/employee/${payload.employeeId}/reports/manager-details/login`,
    );

    yield put(actionCreators.GetManagerDetailsLoginsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetManagerDetailsLoginsError(e.response));
  }
}

export function* onGetManagerDetailsTasks({
  payload,
}: Action<ManagerRequest>): Generator<*, void, *> {
  try {
    if (!payload || !payload.clientId || !payload.employeeId) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.get,
      `/api/v1/reports/client/${payload.clientId}/employee/${payload.employeeId}/reports/manager-details/task`,
    );

    yield put(actionCreators.GetManagerDetailsTasksSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetManagerDetailsTasksError(e.response));
  }
}

export function* ManagerDetailsSaga(): Generator<*, void, void> {
  yield all([
    takeEvery(GetManagerDetails, onGetManagerDetails),
    takeEvery(GetManagerDetailsLogins, onGetManagerDetailsLogins), // TODO: remove the usage of this action
    takeEvery(GetManagerDetailsTasks, onGetManagerDetailsTasks), // TODO: remove the usage of this action
  ]);
}

export default ManagerDetailsSaga;
